import { getInitials, getAMCLogoURL } from "creso-core/utils";
import { isProduction } from "@/utils/common";
import { cn } from "web-design-system";
import { Avatar } from "web-core";

export function AmcLogo({
  amc_code,
  size = "sm",
  className,
}: {
  amc_code: string | null;
  className?: string;
  size?: "sm" | "lg" | "default";
}) {
  return (
    <Avatar
      className={cn(className, "bg-background dark:bg-background")}
      color="default"
      url={getAMCLogoURL(amc_code, isProduction())}
      fallback={getInitials(amc_code || "")}
      size={size}
    />
  );
}
